import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';

import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

import { TipoGastoService, MenuFuncionService, ComunidadService, TenantService } from '../../../../src/app/shared/services';
import { MenuFuncionCodes, TipoGasto, SaveTipoGastoDto, DialogConfirmRequest, DialogConfirmResponse, SearchComunidadRequest, Comunidad, LocalStorageKeys, TenantFeatureFlags } from '../../../../src/app/shared/model';
import { DialogConfirmComponent } from '../../../../src/app/shared/components/modals/dialogConfirm.component';
import { GridComponent } from '@syncfusion/ej2-angular-grids';

@Component({
  selector: 'app-tipoGastoEdit',
  templateUrl: './tipoGastoEdit.component.html',
  styles: [ ]
})

export class TipoGastoEditComponent implements OnInit {

  @ViewChild('comunidadesGrid')
  public comunidadesGrid: GridComponent;

  formGroup: FormGroup;
  comunidadesFormGroup: FormGroup;

  tenantFeatureFlags: TenantFeatureFlags;

  isValidating: boolean = false;
  isSearching: boolean = false;
  isSaving: boolean = false;
  isDeleting: boolean = false;
  isComunidadSearching: boolean = false;
  isComunidadTiposGastosSearching: boolean = false;

  canEdit: boolean = false;
  canDelete: boolean = false;
  canAdd: boolean = false;
  canView: boolean = false;
  canRecurrente: boolean = false;

  msgError: string = "";
  item: TipoGasto;
  comunidadList: Comunidad[];

  constructor (
    private formBuilder: FormBuilder,
    private location: Location,
    public dialog: MatDialog,
    private sharedFunctions: SharedFunctions,
    private route: ActivatedRoute,
    private menuService: MenuFuncionService,
    private tenantService: TenantService,
    private comunidadService: ComunidadService,
    private tipoGastoService: TipoGastoService
  ) {
  }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenuPadre(MenuFuncionCodes.TIPO_GASTO).subscribe(data => {
      if (data != null && data.Success && data?.Result) {

        this.tenantService.getTenantFeatureFlagsById(this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.TenantId)).subscribe(dataTenant => {
          this.isValidating = false;
          if (dataTenant != null && dataTenant.Success) {
            this.tenantFeatureFlags = dataTenant.Result;

            this.canEdit = data.Result.some(x => x == MenuFuncionCodes.TIPO_GASTO_EDIT);
            this.canAdd = data.Result.some(x => x == MenuFuncionCodes.TIPO_GASTO_ADD);
            this.canView = data.Result.some(x => x == MenuFuncionCodes.TIPO_GASTO_LIST);
            this.canDelete = data.Result.some(x => x == MenuFuncionCodes.TIPO_GASTO_DELETE);

            this.loadView();
          }
        },
        (err: HttpErrorResponse) => {
          this.isValidating = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
      else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.onCancel();
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  loadView() {
    this.buildForm();
    this.buildComunidadesForm();

    this.getComunidades();
    this.loadEntity();

    this.menuService.checkMenu(MenuFuncionCodes.GASTO_RECURRENTES).subscribe(data => {
      if (data != null && data.Success && data?.Result) {
        this.canRecurrente = true;
      }
    },
    (err: HttpErrorResponse) => {
      this.sharedFunctions.handleError(err);
    });
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      'Nombre': [null, [Validators.required, Validators.maxLength(150)]],
      'Codigo': [null, [Validators.required, Validators.maxLength(100)]],
      'Activo': [true, Validators.required],
      'EsRecurrente': [false, Validators.required],
      'PeriodicidadRecurrencia': [null],
      'Comunidades': [null]
    });
  }

  buildComunidadesForm() {
    if (!this.tenantFeatureFlags?.HabilitarControlGastos)
      return false;

    this.comunidadesFormGroup = this.formBuilder.group({
      'ComunidadId': [null, Validators.required],
      'MostrarEnResumenExpensa': [true]
    });
  }

  getComunidades() {
    var r = new SearchComunidadRequest(null, null, true, "Nombre", null, null, null, null, null, true);
    this.isComunidadSearching = true;

    this.comunidadService.search(r).subscribe(data => {
      this.isComunidadSearching = false;
      this.comunidadList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isComunidadSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  isProcessing() {
    return (this.isSearching || this.isSaving || this.isDeleting);
  }

  loadEntity() {
    this.route.params.subscribe(params => {
      if (params['id'] != null && params['id'] != '0') {
        var id = Number(params['id']);

        if (id > 0) {
            if (this.canView || this.canEdit) {
              this.isSearching = true;
              this.tipoGastoService.get(id).subscribe(data => {
                this.isSearching = false;
                if (data != null && data.Success) {
                  this.item = data.Result;
                  this.loadComunidades(this.item.Id);

                  if (this.item != null && this.item.Id > 0) {
                    this.formGroup.patchValue(this.item);
                  }
                  else
                    this.msgError = "No se encontró el item seleccionado.";
                }
                else
                  this.msgError = "Ocurrió un error al intentar obtener los datos del item.";
              },
              (err: HttpErrorResponse) => {
                this.isSearching = false;
                this.sharedFunctions.handleError(err, true);
              })
            }
            else {
              this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
              this.onCancel();
            }
        }
        else
          this.msgError = "Item no válido.";
      }
      else
      {
        if (this.canAdd) {
          this.item = new TipoGasto(0, null, null, false, null, [], null, true);
          this.formGroup.patchValue(this.item);
        }
        else {
          this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
          this.onCancel();
        }
      }
    });
  }

  loadComunidades(id) {
    if (!this.tenantFeatureFlags?.HabilitarControlGastos)
      return false;

    this.isComunidadTiposGastosSearching = true;
    this.tipoGastoService.getComunidades(id).subscribe(data => {
      this.isComunidadTiposGastosSearching = false;
      if (data.Success)
        this.item.Comunidades = data.Result;
    },
    (err: HttpErrorResponse) => {
      this.isComunidadTiposGastosSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  getErrorComunidadId() {
    return this.comunidadesFormGroup.get('ComunidadId')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  onComunidadAdd() {
    if (!this.comunidadesFormGroup.valid) {
      this.sharedFunctions.showMessage("Por favor complete todos los datos obligatorios para continuar", "Error");
      return false;
    }

    if (this.item.Comunidades == null)
      this.item.Comunidades = [];

    var index = this.item.Comunidades.findIndex(f => f.ComunidadId == this.comunidadesFormGroup.get('ComunidadId')?.value);
    if (index >= 0) {
      this.item.Comunidades[index] = {
        ...this.comunidadesFormGroup.getRawValue(),
        ...{
          Id: this.item.Comunidades[index].Id ?? 0,
          Comunidad: this.comunidadList.find(f => f.Id == this.comunidadesFormGroup.get('ComunidadId')?.value)?.Nombre
        }
      };
    }
    else
      this.item.Comunidades.push({
        ...this.comunidadesFormGroup.getRawValue(),
        ...{
          Id: 0,
          Comunidad: this.comunidadList.find(f => f.Id == this.comunidadesFormGroup.get('ComunidadId')?.value)?.Nombre
        }
      });

    this.comunidadesGrid.refresh();
    this.buildComunidadesForm();
  }

  onComunidadDelete(item: any) {
    if (item != null && item.index >= 0) {
      if (this.item.Comunidades == null)
        this.item.Comunidades = [];

      this.item.Comunidades.splice(item.index, 1);
      this.comunidadesGrid.refresh();
    }
  }

  getErrorCodigo() {
    var v = this.formGroup.get('Codigo');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorNombre() {
    var v = this.formGroup.get('Nombre');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 150 caracteres alcanzado';
    return '';
  }

  onGuardar() {

    if (!this.formGroup.valid) {
      this.sharedFunctions.showMessage("Por favor complete todos los datos obligatorios para continuar", "Error");
      return false;
    }

    var r = new SaveTipoGastoDto(null, null, null, null, [], true);

    r =
    {
      ...this.formGroup.value,
      ...{
        Id: (this.item?.Id ?? 0),
        Comunidades: this.item?.Comunidades,
      }
    };

    this.isSaving = true;
    this.tipoGastoService.save(r).subscribe(data => {
      this.isSaving = false;
      if (data != null && data.Success && data.Result != null && data.Result.Id > 0) {
        this.sharedFunctions.showMessage("Se guardaron correctamente los datos!", "Operación Exitosa!");
        this.onCancel();
      }
      else
        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
    },
    (err: HttpErrorResponse) => {
      this.isSaving = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  onDelete() {
    if (!this.canDelete)
      return false;

    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: new DialogConfirmRequest(null, "¿Está seguro que desea eliminar el tipo de gasto?", null, null)
    });

    dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
      if (result != null && result.Accepted) {
        this.isDeleting = true;
        this.tipoGastoService.delete(this.item.Id).subscribe(data => {
          this.isDeleting = false;
          if (data != null && data.Success && data.Result) {
            this.sharedFunctions.showMessage("Se eliminaron correctamente los datos!", "Operación Exitosa!");
            this.onCancel();
          }
          else
            this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
        },
        (err: HttpErrorResponse) => {
          this.isDeleting = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
    });
  }

  onCancel() {
    this.location.back();
  }
}
